module.exports = __webpack_public_path__ + "static/media/input-icon-phone~TdTpOXeW.c8f4881b.svg";